import React, { useState } from 'react';
import { Dialog, DialogContent, TextField, IconButton } from '@mui/material';
import { Button } from '../../../components/Button/button';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import { notifyError } from '../../../config/ToastMessage';

const AddMachineryPopup = ({
    open,
    onClose,
    addMachineryData,
    setAddMachineryData,
    handleAddData,
    loading,
    translations,
    language
}) => {
    const [subCategories, setSubCategories] = useState(['']);

    const handleSubCategoryChange = (index, value) => {
        const newSubCategories = [...subCategories];
        newSubCategories[index] = value;
        setSubCategories(newSubCategories);
    };

    const addSubCategory = () => {
        setSubCategories([...subCategories, '']);
    };

    const removeSubCategory = (index) => {
        const newSubCategories = subCategories.filter((_, i) => i !== index);
        setSubCategories(newSubCategories);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!addMachineryData) {
            notifyError("Enter Machinery");
            return;
          }
          if (!subCategories.length) {
            notifyError("Enter at least one Sub Category");
            return;
          }

        const validSubCategories = subCategories.filter(cat => cat.trim() !== '');
        handleAddData(e, validSubCategories);
        setSubCategories(['']);
    };

    return (
        <Dialog
            open={open}
            maxWidth="xs"
            fullWidth
            disableScrollLock
            PaperProps={{
                sx: { borderRadius: "12px" },
            }}
        >
            <div className="assign-div">
                <div className="d-flex justify-content-around align-items-center">
                    <h5 className="p-3 mb-0" style={{ textAlign: "center" }}>
                        {translations[language].addMachinery}
                    </h5>
                </div>
            </div>
            <DialogContent>
                <form noValidate autoComplete="off" onSubmit={handleSubmit}>
                    <TextField
                        fullWidth
                        label={translations[language].enterMachinery}
                        name="addMachineryData"
                        value={addMachineryData}
                        onChange={(e) => {
                            const value = e.target.value;
                            if (value.length <= 50) {
                                setAddMachineryData(value);
                            }
                        }}
                        inputProps={{
                            maxLength: 50,
                        }}
                        className="mb-3"
                    />

                    {subCategories.map((subCategory, index) => (
                        <div key={index} className="d-flex align-items-center gap-2 mb-3" style={{ position: 'relative' }}>
                            <TextField
                                fullWidth
                                label={translations[language].enterSubCategory}
                                value={subCategory}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (value.length <= 50) {
                                        handleSubCategoryChange(index, value);
                                    }
                                }}
                                inputProps={{
                                    maxLength: 50,
                                }}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        paddingRight: index > 0 ? '40px' : '14px'
                                    }
                                }}
                            />
                            {index > 0 && (
                                <IconButton
                                    onClick={() => removeSubCategory(index)}
                                    size="small"
                                    sx={{
                                        position: 'absolute',
                                        right: '8px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        padding: '4px',
                                        minWidth: '20px',
                                        minHeight: '20px',
                                        borderRadius: '50%',

                                    }}
                                >
                                    <CloseIcon sx={{
                                        fontSize: 24,
                                        color: '#ffffff',
                                        backgroundColor: '#3c4856',
                                        borderRadius: '50%',
                                        padding: '2px'
                                    }} />
                                </IconButton>
                            )}
                        </div>
                    ))}

                    <div className="mb-3 d-flex align-items-center gap-2">
                        <IconButton
                            onClick={addSubCategory}
                            size="small"
                            sx={{
                                color: '#ffffff',
                                backgroundColor: '#3c4856',
                                borderRadius: '50%',
                                padding: '1px',
                                '&:hover': {
                                    backgroundColor: '#3c4856'
                                },
                            }}
                        >
                            <AddIcon sx={{ fontSize: 20 }} />
                        </IconButton>
                        <span style={{ fontSize: '14px' }}>
                            {translations[language].subCategory}
                        </span>
                    </div>


                    <div className="d-flex gap-3 mt-2">
                        <button className="cancel-button" onClick={onClose}>
                            {translations[language].cancel}
                        </button>
                        <Button
                            title={translations[language].addMachinery}
                            classname={"assign-task-button"}
                            onClick={handleSubmit}
                            loading={loading}
                        />
                    </div>
                </form>
            </DialogContent>
        </Dialog>
    );
};

export default AddMachineryPopup;